export const LEFT_TITLE = 'Grounded in Silicon Valley';
export const RIGHT_TITLE = 'Powered in Eastern Europe';
export const FOOTER_TEXT = "see what's inside the engine";
